import moment from 'moment';
import { Match, Training } from '../../../models/Calendar';
import {
  ADDRESS, DESCRIPTION, END_TIME, InformTeamParams, MEETING_TIME, START_TIME,
} from '../components/MatchEventModal/MatchEventModalProps';
import { TIME_FORMAT } from '../../../utils/dateUtils';
import { EventType } from '../../../constants/eventTypes';
import { INTERVAL, NAME, TrainingFormSchema } from '../components/TrainingEventModal/TrainingEventModalProps';
import useEventDateTime from '../hooks/useEventDateTime';
import { getUpperCasedDay } from './TimePickerUtil';

export default (
  formState: TrainingFormSchema,
  startDate: Date | undefined,
  endDate: Date | undefined,
  teamId: number,
  event: Match | Training | null,
  informTeamParams?: InformTeamParams,
): Training => {
  const [startDateTime, endDateTime] = useEventDateTime(formState, startDate, endDate);

  return {
    name: formState[NAME],
    description: formState[DESCRIPTION],
    training: {
      ...(!event && ({ teamId })),
      ...(formState[MEETING_TIME]
        && ({ meetingTime: moment(formState[MEETING_TIME]!).format(TIME_FORMAT) })),
    },
    location: {
      displayName: formState[ADDRESS],
    },
    type: EventType.TRAINING,
    ...(!event && ({
      interval: {
        type: 'WEEK',
        length: formState[INTERVAL]!,
        startDate: moment(startDate!).startOf('day').valueOf(),
        startDay: getUpperCasedDay(startDate!),
        endDate: moment(endDate!).endOf('day').valueOf(),
        startTime: moment(formState[START_TIME]!).format(TIME_FORMAT),
        endTime: moment(formState[END_TIME]!).format(TIME_FORMAT),
      },
    })),
    ...(event && ({ id: event.id })),
    ...(event && ({ startDateTime })),
    ...(event && ({ endDateTime })),
    ...(informTeamParams && (informTeamParams)),
  };
};
